// extracted by mini-css-extract-plugin
export default {"list":"YourHomeDropdown_list__bfD9v"};